import styled from 'styled-components'
import { useStudentsPodium } from 'querys/student-projects'
import Image from 'next/legacy/image'
import { useRouter } from 'next/router'
import Wrapper from 'common/wrapper'
import { Typography } from 'common/typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import PodiumFilter from './podium-filter'

const PodiumStyled = styled.section`
  .podium {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
    column-gap: 24px;
    row-gap: 24px;
  }
  .podium-loader {
    color: var(--turquoise);
    margin-block-start: 24px;
    min-height: 58vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const PodiumItemStyled = styled.li`
  background: var(--neutral100);
  color: var(--white);
  border-radius: 8px;
  &:hover {
    filter: drop-shadow(0px 2px 8px rgba(97,112,216,0.5));
  }
  a {
    padding: 16px;
    display: flex;
    gap: 8px;
  }
  .name {
    text-transform: capitalize;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .img-container {
    background: linear-gradient(51.32deg, #FA057C 0%, #0704FE 100%, rgba(196, 196, 196, 0) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    min-width: 42px;
    height: 42px;
    span {
      border-radius: 50%;
    }
  }
`

function Podium() {
  const { data, isLoading } = useStudentsPodium({ defaultPeriod: 'monthly' })
  const { query: { period } } = useRouter()

  const param = period || 'monthly'

  return (
    <PodiumStyled aria-label="Podium de estudiantes destacados">
      <Wrapper maxWidth={1366}>
        <PodiumFilter />
        <ul className="podium" data-cy="students-podium">
          {data?.map((item) => (
            <PodiumItemStyled key={item.id}>
              <a href={`/estudiante/${item.username}`} target="_blank" rel="noopener noreferrer">
                <div className="img-container">
                  <Image src={item.photo} width={40} height={40} alt={item.full_name} />
                </div>
                <div className="student-container">
                  <Typography font="regularBold" className="name">{item.full_name}</Typography>
                  <Typography font="smallRegular" color="var(--lightBlue)">
                    {item.score}
                    {' '}
                    puntos
                  </Typography>
                </div>
              </a>
            </PodiumItemStyled>
          ))}
        </ul>
        {isLoading && (
          <div className="podium-loader">
            <CircularProgress variant="indeterminate" color="inherit" size={80} thickness={5} />
          </div>
        )}
      </Wrapper>
    </PodiumStyled>
  )
}

export default Podium
